export function userIsAuth(): boolean {
  let attribs = false;

  if (window.location.pathname.includes("gate-entry-details")) {
    const parse = JSON.parse(localStorage.getItem("allowedRoutes") || "");
    if (parse.includes("/nod/gate-entry/add-gate-entry")) {
      attribs = parse.includes("/nod/gate-entry/add-gate-entry");
    } else if (parse.includes("/gate-entry/add-gate-entry")) {
      attribs = parse.includes("/gate-entry/add-gate-entry");
    }
  } else if (window.location.pathname.includes("gate-out-details")) {
    const parse = JSON.parse(localStorage.getItem("allowedRoutes") || "");
    if (parse.includes("/gate-entry/gate-out")) {
      attribs = parse.includes("/gate-entry/gate-out");
    } else if (parse.includes("/nod/gate-entry/gate-out")) {
      attribs = parse.includes("/nod/gate-entry/gate-out");
    }
  } else if (
    window.location.pathname.includes("add-user") ||
    window.location.pathname.includes("update-user")
  ) {
    const parse = JSON.parse(localStorage.getItem("allowedRoutes") || "");
    attribs = parse.includes("/management/list-users");
  } else if (window.location.pathname.includes("assign-permissions")) {
    const parse = JSON.parse(localStorage.getItem("allowedRoutes") || "");
    attribs = parse.includes("/management/roles");
  } else if (window.location.pathname.includes("change-password")) {
    attribs = true;
  } else {
    attribs = JSON.parse(localStorage.getItem("allowedRoutes") || "").includes(
      window.location.pathname
    );
  }

  return attribs;
}
